export default class ActionsState {
  //
}
